export default class ActionsState {
  //
}
